<template>
  <b-navbar toggleable="sm" type="light" variant="light">
    <div class="container">
      <b-navbar-brand href="/" @click.prevent="$router.push({ name: 'home' })">
        <img src="../assets/bechterew_logo.svg" style="height: 22px;" />
      </b-navbar-brand>

      <b-nav-text right> <LoginIndicator /> </b-nav-text>
    </div>
  </b-navbar>
</template>

<script>
import LoginIndicator from '@/elements/LoginIndicator';

export default {
  name: 'navigation',
  components: { LoginIndicator },
};
</script>
<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/Navigation.vue